// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import IOsSvg from '@rsuite/icon-font/lib/platform/IOs';
var IOs = createSvgIcon({
  as: IOsSvg,
  ariaLabel: 'i os',
  category: 'platform',
  displayName: 'IOs'
});
export default IOs;